var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Typography } from "@material-ui/core";
import React from "react";
import "../styles/AuthStylesheet.css";
import AuthComponent, { STATE_SIGN_IN, STATE_SIGNED_UP } from "./AuthComponent";
import { FormattedMessage } from "react-intl";
var VALID_AUTH_STATES = [STATE_SIGNED_UP];
var SignUpCompletionComponent = /** @class */ (function (_super) {
    __extends(SignUpCompletionComponent, _super);
    function SignUpCompletionComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismissClicked = function () {
            _this.changeAuthState(STATE_SIGN_IN);
        };
        return _this;
    }
    SignUpCompletionComponent.prototype.getValidAuthStates = function () {
        return VALID_AUTH_STATES;
    };
    // @ts-ignore
    SignUpCompletionComponent.prototype.renderComponent = function (currentAuthState) {
        return (React.createElement("div", { className: "container" },
            React.createElement("h2", { className: "auth-headline" },
                React.createElement(FormattedMessage, { id: "authentication-signup_completion-header" })),
            React.createElement(Typography, null,
                React.createElement(FormattedMessage, { id: "authentication-signup_completion-confirmation_instructions" })),
            React.createElement(Typography, null,
                React.createElement(FormattedMessage, { id: "authentication-signup_completion-sendoff" })),
            React.createElement("a", { className: "auth-link", onClick: this.onDismissClicked },
                React.createElement(FormattedMessage, { id: "authentication-signup_completion-login_link" }))));
    };
    return SignUpCompletionComponent;
}(AuthComponent));
export default SignUpCompletionComponent;
//# sourceMappingURL=SignUpCompletionComponent.js.map